import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import '../css/terms.css';
import { useNavigate } from 'react-router-dom';

function TermsAndConditions() {
  const [terms, setTerms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [logoUrl, setLogoUrl] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTermsAndLogo = async () => {
      try {
        setLoading(true);
        
        // Fetch terms and conditions
        const termsDoc = await getDoc(doc(db, 'app-settings', 'app-settings'));
        
        if (termsDoc.exists()) {
          const data = termsDoc.data();
          setTerms(data['terms-and-conditions'] || []);
        } else {
          setError('Terms and conditions not found');
        }

        // Fetch company logo
        const logoDoc = await getDoc(doc(db, 'settings', 'company'));
        if (logoDoc.exists()) {
          setLogoUrl(logoDoc.data().logoUrl);
        }

        setLoading(false);
      } catch (err) {
        console.error('Error fetching terms:', err);
        setError('Failed to load terms and conditions');
        setLoading(false);
      }
    };

    fetchTermsAndLogo();
  }, []);

  if (loading) {
    return (
      <div className="terms-container">
        <div className="terms-content">
          <div className="loading-wrapper">
            <div className="loading-spinner-large"></div>
            <p className="loading-text">Loading Terms & Conditions...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="terms-container">
        <div className="terms-content">
          <div className="error-wrapper">
            <svg className="error-icon" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="#ef4444" strokeWidth="2"/>
              <path d="M12 8v4M12 16h.01" stroke="#ef4444" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <h2 className="error-title">Error Loading Terms</h2>
            <p className="error-message">{error}</p>
            <button onClick={() => window.location.reload()} className="retry-button">
              Retry
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="terms-container">
      <div className="terms-content">
        {/* Header Section */}
        <div className="terms-header">
          {logoUrl && (
            <div className="terms-logo-section">
              <img src={logoUrl} alt="Company Logo" className="terms-logo" />
            </div>
          )}
          <h1 className="terms-title">Terms & Conditions</h1>
          <p className="terms-subtitle">
            Please read these terms and conditions carefully before using our service
          </p>
          <div className="terms-date">
            Last Updated: {new Date().toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </div>
        </div>

        {/* Terms List */}
        <div className="terms-list">
          {terms.length > 0 ? (
            terms.map((term, index) => (
              <div key={index} className="term-item">
                {/* <div className="term-number">{index + 1}</div> */}
                <div className="term-content">
                  <p className="term-text">{index + 1}. {term}</p>
                </div>
              </div>
            ))
          ) : (
            <div className="no-terms">
              <p>No terms and conditions available at the moment.</p>
            </div>
          )}
        </div>

        {/* Footer Section */}
        <div className="terms-footer">
          <div className="footer-divider"></div>
          <p className="footer-text">
            By using our service, you acknowledge that you have read and understood these terms and conditions.
          </p>
          <button 
            onClick={() => navigate('/')} 
            className="back-to-form-button"
          >
            ← Back to Form
          </button>
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditions;